define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WaParcelTypeDomain = void 0;
    class WaParcelTypeDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: WaParcelTypeDomain.SrnParcel, value: "SRN Parcel" },
                    { key: WaParcelTypeDomain.LandownerParcel, value: "Landowner Parcel" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[WaParcelTypeDomain.SrnParcel] = 0;
                this.KeyIndex[WaParcelTypeDomain.LandownerParcel] = 1;
                this.ValueIndex = {};
                this.ValueIndex["SRN Parcel"] = 0;
                this.ValueIndex["Landowner Parcel"] = 1;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.WaParcelTypeDomain = WaParcelTypeDomain;
    Object.defineProperty(WaParcelTypeDomain, "SrnParcel", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(WaParcelTypeDomain, "LandownerParcel", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(WaParcelTypeDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
